import React, {PureComponent} from "react";
import Dotdotdot from "react-dotdotdot";
import AssetThumbnail from "../../AssetThumbnail/AssetThumbnail";
import common from "../../../utils/common";
import "./SearchItem.scss";
import PlayIcon from "../../../ui/PlayIcon/PlayIcon";
import Api from "../../../utils/api_calls";
import ConfigurationHelper from "../../../configuration/ClientConfigurationHelper";

const RoundedPlayIcon = () => <span className="rounded-play-icon">
        <PlayIcon />
    </span>;

class SearchResults extends PureComponent {
    state = {
        clampText : false,
        products: null
    }
    loadProducts = () => {
        const {asset} = this.props;
        Api.products(common.getProductsEndpoint(asset))
            .then(response => {
                this.setState({products: response.data.matches});
                return response.data && response.data.matches.length > 0;
            })
            .then(hasProducts=> {
                if (!hasProducts && ConfigurationHelper.useRecommendedProducts() && !common.isPhoto(asset)) {
                    Api.recommendedProducts(
                        common.getRecommendedProductsEndpoint(asset),
                        ConfigurationHelper.getLatestVideosChannelId())
                        .then( response => this.setState({products: response.data.splice(0,4)}) );
                }
            });
    }
    componentDidMount(){
        this.setState({ clampText: true});
        this.loadProducts();
    }
    render() {
        const {asset} = this.props;
        const {clampText, products} = this.state;
        const showPlayIcon = asset.entityType === 1;
        const publishedDate = common.getDateFromUnixSearchFormat(asset.date_created);
        return <div className={"col-12 col-sm-12 col-md-9 ml-auto mr-auto pt-3 pb-3"} style={{backgroundColor:"#ffffff"}}>
            <a href={common.generateAssetUrlFrom(asset)} className={"search-item"}>
                <div className={"search-item-thumbnail"}>
                    <AssetThumbnail thumbnailUrl={common.getThumbnail(asset)} alt={asset.title}
                                    lazyLoadingThumbnails={false}
                                    isPhoto={common.isPhoto(asset)}/>
                    {products && <div className={"products-available"}>{products.length} PRODUCTS</div>}
                    {showPlayIcon && <RoundedPlayIcon/>}
                </div>
                <div className={"search-item-details"}>
                    { clampText && <Dotdotdot className={"search-item-details-title"} clamp={2}>
                        {asset.title}
                    </Dotdotdot> }
                    <div className={"search-item-details-published"}>
                        <div className={"published mobile"}>
                            <span>Published on </span>
                            {publishedDate && <span>{publishedDate}</span>}
                        </div>
                    </div>
                    {clampText && <Dotdotdot className={"search-item-details-description"} clamp={2}>
                        {asset.description}
                    </Dotdotdot>}
                </div>
            </a>

        </div>
    }
}

export default SearchResults;